export default __webpack_public_path__ + "static/media/city_light_reduced.76794751.jpg";